/**
 * API endpoints for the current user
 */
export class MeAPI {
    apiClient;
    authService;
    studentsAPI;
    matchesAPI;
    /**
     * Create a new MeAPI
     * @param apiClient - The API client
     * @param authService - The authentication service
     * @param studentsAPI - The students API
     * @param matchesAPI - The matches API
     */
    constructor(apiClient, authService, studentsAPI, matchesAPI) {
        this.apiClient = apiClient;
        this.authService = authService;
        this.studentsAPI = studentsAPI;
        this.matchesAPI = matchesAPI;
    }
    /**
     * Get the current user's profile
     * @returns Promise with the user profile
     */
    async getMyProfile() {
        const userId = this.authService.getUserId();
        if (!userId)
            return null;
        return await this.studentsAPI.getStudent(userId);
    }
    /**
     * Get the current user's stats
     * @returns Promise with the user stats
     */
    async getMyStats() {
        const username = this.authService.getUsername();
        if (!username)
            return null;
        return await this.matchesAPI.getPlayerRating(username);
    }
    /**
     * Get the current user's subscriptions
     * @returns Promise with the user subscriptions
     */
    async getMySubscriptions() {
        const userId = this.authService.getUserId();
        if (!userId)
            return null;
        return await this.studentsAPI.getStudentSubscriptions(userId);
    }
}
